/* eslint-disable max-lines-per-function */

import { useState } from 'react';
import { Tabs, Typography } from '@equinor/eds-core-react';
import { StaticImage } from '../../../components/StaticImage';
import { CategorizedImages } from '../../../hooks/useFetchCategorizedImages';
import * as Styled from './GeneratedImages.styled';
import { ImageSlideshow } from '../../../components/ImageSlideshow/ImageSlideshow';

const { List, Tab, Panels, Panel } = Tabs;

interface GeneratedImagesProps {
  images?: CategorizedImages | null;
  orchestrationId?: string;
}

type TabConfig = {
  label: string;
  data: string[] | undefined;
};

export const GeneratedImages = ({
  images,
  orchestrationId,
}: GeneratedImagesProps) => {
  const [activeTab, setActiveTab] = useState<number | string>(0);

  const tabs: TabConfig[] = [
    {
      label: 'Histograms',
      data: images?.histograms,
    },
    {
      label: 'Cross Section Grain Size',
      data: images?.crossSectionGrainSize,
    },
    {
      label: 'Cross Section Architecture',
      data: images?.crossSectionArchitecture,
    },
    {
      label: 'Bathymetry and Architecture',
      data: images?.bathymetryArchitecture,
    },
    {
      label: 'Cross Section Deposition Age',
      data: images?.crossSectionDepositionAge,
    },
    {
      label: 'Bathymetry and Deposition Rate',
      data: images?.bathymetryDepositionRate,
    },
  ];

  const hasImages = tabs.some((tab) => tab.data && tab.data.length > 0);

  return (
    <Styled.Container>
      <Typography variant="h5">Generated Images</Typography>

      <Styled.TabsWrapper>
        <Tabs activeTab={activeTab} onChange={setActiveTab}>
          <List>
            {tabs.map((tab, index) => (
              <Tab key={index}>{tab.label}</Tab>
            ))}
          </List>
          <Panels>
            {tabs.map((tab, index) => (
              <Panel key={index}>
                <Styled.ImagePanel>
                  {!hasImages || !tab.data || tab.data.length === 0 ? (
                    <Styled.NoImagesMessage>
                      <Typography variant="body_short" color="textTertiary">
                        No images available yet.
                      </Typography>
                    </Styled.NoImagesMessage>
                  ) : tab.data.length > 1 ? (
                    <ImageSlideshow
                      images={tab.data}
                      orchestrationId={orchestrationId || ''}
                    />
                  ) : (
                    <Styled.ImageGridCentered>
                      {tab.data.map((filename, imgIndex) => (
                        <Styled.ImageWrapperCentered key={imgIndex}>
                          <StaticImage
                            filename={filename}
                            orchestrationId={orchestrationId || ''}
                            alt={`${tab.label} ${imgIndex + 1}`}
                          />
                        </Styled.ImageWrapperCentered>
                      ))}
                    </Styled.ImageGridCentered>
                  )}
                </Styled.ImagePanel>
              </Panel>
            ))}
          </Panels>
        </Tabs>
      </Styled.TabsWrapper>
    </Styled.Container>
  );
};
